import { render, staticRenderFns } from "./TaxonomyView.vue?vue&type=template&id=3e09c54a&scoped=true"
import script from "./TaxonomyView.vue?vue&type=script&lang=js"
export * from "./TaxonomyView.vue?vue&type=script&lang=js"
import style0 from "./TaxonomyView.vue?vue&type=style&index=0&id=3e09c54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09c54a",
  null
  
)

export default component.exports